import axios from "axios";

async function setImagePosted(url, posted) {
    const result = await axios("/api/setImagePosted?url=" + url + "&posted=" + posted);
    console.log(result.data);
}

export default setImagePosted;
